<template>
<div class="not-found">
    <div class="not-found-wrap">
        <h1>404</h1>
        <p>抱歉！页面无法访问……点击下方按钮返回首页</p>
        <router-link to="./"><img src="../../static/img/ibroadcast/back2home3.png" width="390"></router-link>
    </div>
</div>
</template>
<script>
import '../../static/style/common/notfound.scss'
</script>



// WEBPACK FOOTER //
// notfound.vue?7c741a9a